import PropTypes from "prop-types";
import moment from "moment";
import getSymbolFromCurrency from "currency-symbol-map";
import Modal from "../modal-new";
import { getDivisor } from "../../utils/stripe-helpers";

const PendingInvoiceModal = (_, { locals }) => {
  const { activeUser, organizationRoleName, pendingInvoices = [] } = locals;

  if (activeUser.organizationId && organizationRoleName !== "Owner") {
    return (
      <Modal className="pending-invoice" title="Action Required: Payment Issue">
        <div className="body max-w-[32rem]">
          <p className="mb-8 p2">
            Your organization has a failed payment. If it's not resolved, you’ll
            lose access to your account — and your clients’ accounts — by the
            14th of the month. Please contact your organization owner as soon as
            possible so they can update the billing details and prevent service
            interruption.
          </p>
        </div>
      </Modal>
    );
  }

  const isOrg = !!activeUser.organizationId;

  return (
    <Modal
      className="pending-invoice"
      title="Payment Failed – Immediate Action Needed"
    >
      <div className="body max-w-[44rem]">
        {pendingInvoices.length > 0 && (
          <>
            <span className="text-[--danger]">Pending</span>
            <h2 className="mt-1 mb-2">
              {getSymbolFromCurrency(pendingInvoices[0].currency)}
              {pendingInvoices.reduce(
                (total, invoice) => total + invoice.total,
                0
              ) / getDivisor(pendingInvoices[0].currency)}{" "}
              {pendingInvoices[0].currency.toUpperCase()}
            </h2>
            <section role="table-wrapper" data-borders-inside="true">
              <table role="report-table" className="!rounded-lg">
                <thead>
                  <tr>
                    <th>Invoice Number</th>
                    <th>Invoice Date</th>
                    <th>Amount</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {pendingInvoices.map((invoice) => {
                    const {
                      id,
                      number,
                      effective_at,
                      created,
                      currency,
                      total,
                      hosted_invoice_url,
                    } = invoice;
                    const symbol = getSymbolFromCurrency(currency);
                    const divisor = getDivisor(currency);
                    const amount = total / divisor;
                    return (
                      <tr key={id}>
                        <td>{number}</td>
                        <td>
                          {moment((effective_at || created) * 1000).format(
                            "MMM D, YYYY"
                          )}
                        </td>
                        <td>
                          {symbol}
                          {amount} {currency.toUpperCase()}
                        </td>
                        <td>
                          <a
                            href={hosted_invoice_url}
                            data-button-type="primary"
                            role="button"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="!p-0 !h-8"
                          >
                            Pay
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </section>
          </>
        )}
        <p className="mt-4 p2">
          Your{isOrg ? " organization's" : ""} recent payment didn’t go through.
          To avoid losing access to your account —
          {isOrg ? " and your teams'" : ""} and clients' accounts — please
          settle the outstanding invoice by the 14th of the month.
        </p>

        <p className="mt-4 p2">
          Let's make sure your coaching continues smoothly.
        </p>

        <p className="mt-4 p2">
          Click the <strong>Pay</strong> button above to view your invoice and
          complete the payment.
        </p>

        <div className="chip info mt-8">
          If you have any issues in payments feel free to contact us by clicking
          the button below.
        </div>
      </div>

      <footer>
        <a
          data-button-type="outline"
          role="button"
          href="/coaching-portal/support/contact"
        >
          <span>Contact Us</span>
        </a>
      </footer>
    </Modal>
  );
};

PendingInvoiceModal.contextTypes = { locals: PropTypes.object };

export default PendingInvoiceModal;
